/**
 * cd-img-lookahead — nudge below-the-fold lazy images to fetch ~1.5 viewports
 * earlier than the browser's native look-ahead, so they're decoded before they
 * scroll into view (reduces "pop-in" on slow connections).
 *
 * Purely additive and non-destructive:
 *   - Only acts on images APPROACHING the viewport (rootMargin), so initial
 *     page load (and Lighthouse) is unchanged — far-below images stay lazy
 *     until you scroll near them.
 *   - Layout is never touched (images already reserve their box via
 *     width/height), so this cannot cause CLS.
 *   - No-ops entirely if IntersectionObserver is unavailable.
 *   - Reversible: remove the one <script> tag in theme.liquid and it's gone.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry.isIntersecting) continue;
        var img = entry.target;
        try {
          // Flip to eager so the browser fetches now instead of waiting for
          // its (sometimes late, on slow connections) native lazy trigger.
          img.fetchPriority = 'high';
          img.loading = 'eager';
        } catch (_) {}
        io.unobserve(img);
      }
    },
    // ~2.5 viewports of lead time top and bottom — wide enough to win the
    // fetch race against fast mobile scrolling (was 1.5, which lost it and
    // left cards painting blank as they scrolled into view).
    { rootMargin: '250% 0px 250% 0px' }
  );

  function observe(root) {
    var imgs = (root || document).querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) io.observe(imgs[i]);
  }

  function start() {
    observe(document);
    // Catch lazy images added later (infinite scroll, quick-add, section
    // re-renders) without re-scanning the whole DOM on every mutation.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches('img[loading="lazy"]')) io.observe(node);
            else if (node.querySelectorAll) observe(node);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
